import { render, staticRenderFns } from "./documentScanning.vue?vue&type=template&id=9420ebe4&"
import script from "./documentScanning.vue?vue&type=script&lang=js&"
export * from "./documentScanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports